import type { EuAppLanguage } from '@/i18n/eu-locales';
import type { AuthStrings } from '@/components/auth/strings';

export const EU_AUTH_STRINGS = {
  bg: {
    tagline: 'AI made right',
    titleSignup: 'Създайте своя акаунт',
    titleLogin: 'Добре дошъл отново',
    introSignup: 'Запазете вашите чатове и вземете асистент, който ви помни.',
    google: 'Продължете с Google',
    divider: 'или',
    showPassword: 'Показване на паролата',
    hidePassword: 'Скриване на паролата',
    submitSignup: 'Създаване на акаунт',
    submitLogin: 'влезте',
    switchToLoginPrefix: 'Вече имате акаунт?',
    switchToLogin: 'влезте',
    switchToSignupPrefix: 'Нов сте в Poneva?',
    switchToSignup: 'Създаване на акаунт',
    close: 'затвори',
    verificationTitle: 'Проверете входящата си кутия',
    verificationBody: 'Изпратихме защитена връзка до',
    verificationHint:
      'Отворете имейл връзката, за да създадете своя акаунт — всяко устройство работи. Вашата покана чака междувременно.',
    verificationAgain: 'Използвайте друг имейл адрес',
    verifying: 'Потвърждаване на вашия имейл и създаване на вашия акаунт…',
    confirmPasswordTitle: 'Потвърдете паролата си',
    confirmPasswordBody:
      'Вашият имейл е потвърден. Отворихте връзката в друг браузър, така че въведете паролата, която сте избрали, за да създадете своя акаунт, и влезте тук.',
    confirmPasswordPlaceholder: 'Вашата парола',
    confirmPasswordSubmit: 'Създайте акаунт и влезте',
    errors: {
      email_taken: 'Този имейл вече е регистриран.',
      bad_credentials: 'Грешен имейл или парола.',
      rate_limited: 'Твърде много опити — изчакайте малко и опитайте отново.',
      invalid_input: 'Въведете валиден имейл и парола от поне 8 знака.',
      cancelled: 'Входът бе отменен.',
      expired: 'Влизането отне твърде много време — моля, опитайте отново.',
      unverified_email: 'Вашият акаунт в Google няма потвърден имейл адрес.',
      account_link_required:
        'Акаунт с този адрес вече съществува. Влезте с имейл, за да свържете Google.',
      email_verification_required:
        'Потвърдете отделно имейл адреса, преди да използвате този акаунт в Google.',
      invalid_invite: 'Тази покана е невалидна, изтекла е или вече е била използвана.',
      verification_expired:
        'Тази връзка за потвърждение е невалидна, изтекла или вече е използвана.',
      verification_password_required:
        'Въведете паролата, която сте избрали при регистрацията, за да завършите на това устройство.',
      verification_wrong_password:
        'Грешна парола. Въведете паролата, която сте избрали при регистрацията.',
      oauth_failed: 'Не можах да вляза с Google. Моля, опитайте отново.',
      oauth_unavailable: 'Влизането в Google не е налично в момента.',
      server_unavailable: 'В момента услугата не е достъпна. Моля, опитайте отново след малко.',
      logout_incomplete:
        'Това устройство може все още да е влязло в профила, когато приложението се стартира отново. Ако е така, излезте отново.',
      generic: 'Нещо се обърка. Моля, опитайте отново.',
    },
  },
  hr: {
    tagline: 'AI made right',
    titleSignup: 'Kreirajte svoj račun',
    titleLogin: 'Dobro došao nazad',
    introSignup: 'Zadržite svoje razgovore i nabavite pomoćnika koji vas pamti.',
    google: 'Nastavite s Googleom',
    divider: 'ili',
    showPassword: 'Prikaži lozinku',
    hidePassword: 'Sakrij lozinku',
    submitSignup: 'Napravi račun',
    submitLogin: 'Prijavite se',
    switchToLoginPrefix: 'Već imate račun?',
    switchToLogin: 'Prijavite se',
    switchToSignupPrefix: 'Novi korisnik Poneva?',
    switchToSignup: 'Napravi račun',
    close: 'Zatvori',
    verificationTitle: 'Provjerite svoju pristiglu poštu',
    verificationBody: 'Poslali smo sigurnu vezu na',
    verificationHint:
      'Otvorite vezu e-pošte da biste kreirali svoj račun — svaki uređaj radi. Vaša pozivnica čeka u međuvremenu.',
    verificationAgain: 'Koristite drugu adresu e-pošte',
    verifying: 'Potvrđivanje vaše e-pošte i stvaranje vašeg računa…',
    confirmPasswordTitle: 'Potvrdite svoju lozinku',
    confirmPasswordBody:
      'Vaša e-pošta je potvrđena. Otvorili ste vezu u drugom pregledniku, pa unesite lozinku koju ste odabrali za izradu računa i prijavite se ovdje.',
    confirmPasswordPlaceholder: 'Vaša lozinka',
    confirmPasswordSubmit: 'Kreirajte račun i prijavite se',
    errors: {
      email_taken: 'Taj je email već registriran.',
      bad_credentials: 'Pogrešna adresa e-pošte ili lozinka.',
      rate_limited: 'Previše pokušaja — pričekajte trenutak i pokušajte ponovno.',
      invalid_input: 'Unesite važeći email i lozinku od najmanje 8 znakova.',
      cancelled: 'Prijava je otkazana.',
      expired: 'Prijava je trajala predugo — pokušajte ponovo.',
      unverified_email: 'Vaš Google račun nema potvrđenu adresu e-pošte.',
      account_link_required:
        'Račun s tom adresom već postoji. Prijavite se putem e-pošte da biste povezali Google.',
      email_verification_required:
        'Prije korištenja tog Google računa zasebno potvrdite adresu e-pošte.',
      invalid_invite: 'Ta je pozivnica nevažeća, istekla je ili je već iskorištena.',
      verification_expired: 'Ta poveznica za potvrdu nije važeća, istekla je ili je već korištena.',
      verification_password_required:
        'Unesite zaporku koju ste odabrali prilikom prijave da biste završili na ovom uređaju.',
      verification_wrong_password:
        'Pogrešna lozinka. Unesite lozinku koju ste odabrali prilikom prijave.',
      oauth_failed: 'Ne mogu se prijaviti s Googleom. Molimo pokušajte ponovo.',
      oauth_unavailable: 'Google prijava trenutno nije dostupna.',
      server_unavailable: 'Usluga trenutno nije dostupna. Pokušajte ponovno uskoro.',
      logout_incomplete:
        'Ovaj uređaj možda će i dalje biti prijavljen kad se aplikacija ponovno pokrene. Ako jest, ponovno se odjavite.',
      generic: 'Nešto nije u redu. Molimo pokušajte ponovo.',
    },
  },
  cs: {
    tagline: 'AI made right',
    titleSignup: 'Vytvořte si účet',
    titleLogin: 'Vítejte zpět',
    introSignup: 'Udržujte své chaty a získejte asistenta, který si vás pamatuje.',
    google: 'Pokračujte s Googlem',
    divider: 'nebo',
    showPassword: 'Zobrazit heslo',
    hidePassword: 'Skrýt heslo',
    submitSignup: 'Vytvořit účet',
    submitLogin: 'Přihlaste se',
    switchToLoginPrefix: 'Už máte účet?',
    switchToLogin: 'Přihlaste se',
    switchToSignupPrefix: 'Jste v Ponevě nový?',
    switchToSignup: 'Vytvořit účet',
    close: 'Zavřít',
    verificationTitle: 'Zkontrolujte si doručenou poštu',
    verificationBody: 'Poslali jsme zabezpečený odkaz na',
    verificationHint:
      'Otevřete e-mailový odkaz a vytvořte si účet – funguje jakékoli zařízení. Vaše pozvání mezitím čeká.',
    verificationAgain: 'Použijte jinou e-mailovou adresu',
    verifying: 'Ověření vašeho e-mailu a vytvoření účtu…',
    confirmPasswordTitle: 'Potvrďte své heslo',
    confirmPasswordBody:
      'Váš email je ověřen. Odkaz jste otevřeli v jiném prohlížeči, zadejte tedy heslo, které jste si zvolili pro vytvoření účtu, a přihlaste se zde.',
    confirmPasswordPlaceholder: 'Vaše heslo',
    confirmPasswordSubmit: 'Vytvořte si účet a přihlaste se',
    errors: {
      email_taken: 'Tento e-mail je již zaregistrován.',
      bad_credentials: 'Chybný e-mail nebo heslo.',
      rate_limited: 'Příliš mnoho pokusů – chvíli počkejte a zkuste to znovu.',
      invalid_input: 'Zadejte platný e-mail a heslo o délce alespoň 8 znaků.',
      cancelled: 'Přihlášení bylo zrušeno.',
      expired: 'Přihlášení trvalo příliš dlouho – zkuste to prosím znovu.',
      unverified_email: 'Váš účet Google nemá žádnou ověřenou e-mailovou adresu.',
      account_link_required:
        'Účet s touto adresou již existuje. Chcete-li propojit Google, přihlaste se pomocí e-mailu.',
      email_verification_required:
        'Před použitím daného účtu Google ověřte e-mailovou adresu samostatně.',
      invalid_invite: 'Tato pozvánka je neplatná, její platnost vypršela nebo již byla použita.',
      verification_expired:
        'Tento ověřovací odkaz je neplatný, vypršela jeho platnost nebo byl již použit.',
      verification_password_required:
        'Pro dokončení na tomto zařízení zadejte heslo, které jste zvolili při registraci.',
      verification_wrong_password:
        'Nesprávné heslo. Zadejte heslo, které jste si zvolili při registraci.',
      oauth_failed: 'Nelze se přihlásit pomocí Google. Zkuste to prosím znovu.',
      oauth_unavailable: 'Přihlášení přes Google není momentálně dostupné.',
      server_unavailable: 'Služba je momentálně nedostupná. Zkuste to za chvíli znovu.',
      logout_incomplete:
        'Toto zařízení může být po dalším spuštění aplikace stále přihlášené. Pokud ano, odhlaste se znovu.',
      generic: 'Něco se pokazilo. Zkuste to prosím znovu.',
    },
  },
  da: {
    tagline: 'AI made right',
    titleSignup: 'Opret din konto',
    titleLogin: 'Velkommen tilbage',
    introSignup: 'Hold dine chats og få en assistent, der husker dig.',
    google: 'Fortsæt med Google',
    divider: 'eller',
    showPassword: 'Vis adgangskode',
    hidePassword: 'Skjul adgangskode',
    submitSignup: 'Opret konto',
    submitLogin: 'Log ind',
    switchToLoginPrefix: 'Har du allerede en konto?',
    switchToLogin: 'Log ind',
    switchToSignupPrefix: 'Ny til Poneva?',
    switchToSignup: 'Opret konto',
    close: 'Luk',
    verificationTitle: 'Tjek din indbakke',
    verificationBody: 'Vi sendte et sikkert link til',
    verificationHint:
      'Åbn e-mail-linket for at oprette din konto - enhver enhed virker. Din invitation venter i mellemtiden.',
    verificationAgain: 'Brug en anden e-mailadresse',
    verifying: 'Bekræfter din e-mail og opretter din konto...',
    confirmPasswordTitle: 'Bekræft din adgangskode',
    confirmPasswordBody:
      'Din e-mail er bekræftet. Du åbnede linket i en anden browser, så indtast den adgangskode, du valgte for at oprette din konto, og log ind her.',
    confirmPasswordPlaceholder: 'Din adgangskode',
    confirmPasswordSubmit: 'Opret konto og log ind',
    errors: {
      email_taken: 'Den e-mail er allerede registreret.',
      bad_credentials: 'Forkert e-mail eller adgangskode.',
      rate_limited: 'For mange forsøg – vent et øjeblik og prøv igen.',
      invalid_input: 'Indtast en gyldig e-mail og en adgangskode på mindst 8 tegn.',
      cancelled: 'Login blev annulleret.',
      expired: 'Login tog for lang tid – prøv venligst igen.',
      unverified_email: 'Din Google-konto har ingen bekræftet e-mailadresse.',
      account_link_required:
        'Der findes allerede en konto med den adresse. Log ind med e-mail for at linke Google.',
      email_verification_required:
        'Bekræft e-mailadressen separat, før du bruger den pågældende Google-konto.',
      invalid_invite: 'Denne invitation er ugyldig, udløbet eller allerede blevet brugt.',
      verification_expired:
        'Dette bekræftelseslink er ugyldigt, udløbet eller allerede blevet brugt.',
      verification_password_required:
        'Indtast den adgangskode, du valgte ved tilmeldingen for at afslutte på denne enhed.',
      verification_wrong_password:
        'Forkert adgangskode. Indtast den adgangskode, du valgte ved tilmelding.',
      oauth_failed: 'Kunne ikke logge ind med Google. Prøv venligst igen.',
      oauth_unavailable: 'Google-login er ikke tilgængelig lige nu.',
      server_unavailable: 'Tjenesten er ikke tilgængelig lige nu. Prøv igen snart.',
      logout_incomplete:
        'Denne enhed kan stadig være logget ind, når appen starter igen. Log i så fald ud igen.',
      generic: 'Noget gik galt. Prøv venligst igen.',
    },
  },
  nl: {
    tagline: 'AI made right',
    titleSignup: 'Maak uw account aan',
    titleLogin: 'Welkom terug',
    introSignup: 'Bewaar uw chats en zorg voor een assistent die u onthoudt.',
    google: 'Ga verder met Google',
    divider: 'of',
    showPassword: 'Wachtwoord tonen',
    hidePassword: 'Wachtwoord verbergen',
    submitSignup: 'Account aanmaken',
    submitLogin: 'Inloggen',
    switchToLoginPrefix: 'Heeft u al een account?',
    switchToLogin: 'Inloggen',
    switchToSignupPrefix: 'Nieuw bij Poneva?',
    switchToSignup: 'Account aanmaken',
    close: 'Sluiten',
    verificationTitle: 'Controleer je inbox',
    verificationBody: 'We hebben een beveiligde link gestuurd naar',
    verificationHint:
      'Open de e-maillink om uw account aan te maken: elk apparaat werkt. Uw uitnodiging wacht in de tussentijd.',
    verificationAgain: 'Gebruik een ander e-mailadres',
    verifying: 'Uw e-mailadres verifiëren en uw account aanmaken...',
    confirmPasswordTitle: 'Bevestig uw wachtwoord',
    confirmPasswordBody:
      'Uw e-mailadres is geverifieerd. Je hebt de link in een andere browser geopend, dus voer het wachtwoord in dat je hebt gekozen om je account aan te maken en log hier in.',
    confirmPasswordPlaceholder: 'Uw wachtwoord',
    confirmPasswordSubmit: 'Account aanmaken en inloggen',
    errors: {
      email_taken: 'Dat e-mailadres is al geregistreerd.',
      bad_credentials: 'Verkeerd e-mailadres of wachtwoord.',
      rate_limited: 'Te veel pogingen. Wacht even en probeer het opnieuw.',
      invalid_input: 'Voer een geldig e-mailadres en een wachtwoord van minimaal 8 tekens in.',
      cancelled: 'Het inloggen is geannuleerd.',
      expired: 'Het inloggen duurde te lang. Probeer het opnieuw.',
      unverified_email: 'Uw Google-account heeft geen geverifieerd e-mailadres.',
      account_link_required:
        'Er bestaat al een account met dat adres. Meld u aan met uw e-mailadres om Google te koppelen.',
      email_verification_required:
        'Verifieer het e-mailadres afzonderlijk voordat u dat Google-account gebruikt.',
      invalid_invite: 'Die uitnodiging is ongeldig, verlopen of al gebruikt.',
      verification_expired: 'Die verificatielink is ongeldig, verlopen of al gebruikt.',
      verification_password_required:
        'Voer het wachtwoord in dat je hebt gekozen bij het aanmelden om op dit apparaat te voltooien.',
      verification_wrong_password:
        'Verkeerd wachtwoord. Voer het wachtwoord in dat u bij het aanmelden heeft gekozen.',
      oauth_failed: 'Kan niet inloggen met Google. Probeer het opnieuw.',
      oauth_unavailable: 'Inloggen bij Google is momenteel niet beschikbaar.',
      server_unavailable:
        'De service is momenteel niet beschikbaar. Probeer het binnenkort opnieuw.',
      logout_incomplete:
        'Dit apparaat kan nog ingelogd zijn wanneer de app opnieuw start. Log in dat geval opnieuw uit.',
      generic: 'Er is iets misgegaan. Probeer het opnieuw.',
    },
  },
  et: {
    tagline: 'AI made right',
    titleSignup: 'Looge oma konto',
    titleLogin: 'Tere tulemast tagasi',
    introSignup: 'Jätkake vestlusi ja hankige assistent, kes teid meeles peab.',
    google: "Jätkake Google'iga",
    divider: 'või',
    showPassword: 'Näita parooli',
    hidePassword: 'Peida parool',
    submitSignup: 'Loo konto',
    submitLogin: 'Logi sisse',
    switchToLoginPrefix: 'Kas teil on juba konto?',
    switchToLogin: 'Logi sisse',
    switchToSignupPrefix: 'Uus Ponevas?',
    switchToSignup: 'Loo konto',
    close: 'Sule',
    verificationTitle: 'Kontrollige oma postkasti',
    verificationBody: 'Saatsime turvalise lingi aadressile',
    verificationHint:
      'Konto loomiseks avage meililink – mis tahes seade töötab. Teie kutse ootab seni.',
    verificationAgain: 'Kasutage teist e-posti aadressi',
    verifying: 'E-posti aadressi kinnitamine ja konto loomine…',
    confirmPasswordTitle: 'Kinnitage oma parool',
    confirmPasswordBody:
      'Teie e-post on kinnitatud. Avasite lingi teises brauseris, seega sisestage konto loomiseks valitud parool ja logige siin sisse.',
    confirmPasswordPlaceholder: 'Teie parool',
    confirmPasswordSubmit: 'Loo konto ja logi sisse',
    errors: {
      email_taken: 'See email on juba registreeritud.',
      bad_credentials: 'Vale e-posti aadress või parool.',
      rate_limited: 'Liiga palju katseid – oodake hetk ja proovige uuesti.',
      invalid_input: 'Sisestage kehtiv e-posti aadress ja vähemalt 8 tähemärgi pikkune parool.',
      cancelled: 'Sisselogimine tühistati.',
      expired: 'Sisselogimine võttis liiga kaua aega – proovige uuesti.',
      unverified_email: "Teie Google'i kontol pole kinnitatud e-posti aadressi.",
      account_link_required:
        "Selle aadressiga konto on juba olemas. Google'i linkimiseks logige sisse e-postiga.",
      email_verification_required:
        "Enne selle Google'i konto kasutamist kinnitage e-posti aadress eraldi.",
      invalid_invite: 'See kutse on kehtetu, aegunud või on juba kasutatud.',
      verification_expired: 'See kinnituslink on kehtetu, aegunud või on juba kasutatud.',
      verification_password_required:
        'Selles seadmes lõpetamiseks sisestage registreerumisel valitud parool.',
      verification_wrong_password: 'Vale parool. Sisestage registreerumisel valitud parool.',
      oauth_failed: "Google'iga ei saanud sisse logida. Palun proovi uuesti.",
      oauth_unavailable: "Google'i sisselogimine pole praegu saadaval.",
      server_unavailable: 'Teenus pole praegu saadaval. Proovige varsti uuesti.',
      logout_incomplete:
        'See seade võib rakenduse järgmisel käivitamisel olla endiselt sisse logitud. Sel juhul logige uuesti välja.',
      generic: 'Midagi läks valesti. Palun proovi uuesti.',
    },
  },
  fi: {
    tagline: 'AI made right',
    titleSignup: 'Luo tilisi',
    titleLogin: 'Tervetuloa takaisin',
    introSignup: 'Pidä keskustelut ja hanki avustaja, joka muistaa sinut.',
    google: 'Jatka Googlella',
    divider: 'tai',
    showPassword: 'Näytä salasana',
    hidePassword: 'Piilota salasana',
    submitSignup: 'Luo tili',
    submitLogin: 'Kirjaudu sisään',
    switchToLoginPrefix: 'Onko sinulla jo tili?',
    switchToLogin: 'Kirjaudu sisään',
    switchToSignupPrefix: 'Uusi Poneva?',
    switchToSignup: 'Luo tili',
    close: 'Sulje',
    verificationTitle: 'Tarkista postilaatikkosi',
    verificationBody: 'Lähetimme suojatun linkin osoitteeseen',
    verificationHint:
      'Luo tili avaamalla sähköpostilinkki – mikä tahansa laite toimii. Kutsusi odottaa sillä välin.',
    verificationAgain: 'Käytä toista sähköpostiosoitetta',
    verifying: 'Vahvistetaan sähköpostiosoitettasi ja luodaan tiliäsi…',
    confirmPasswordTitle: 'Vahvista salasanasi',
    confirmPasswordBody:
      'Sähköpostisi on vahvistettu. Avasit linkin toisella selaimella, joten kirjoita salasana, jonka valitset tilin luomiseen ja kirjaudu sisään tästä.',
    confirmPasswordPlaceholder: 'Salasanasi',
    confirmPasswordSubmit: 'Luo tili ja kirjaudu sisään',
    errors: {
      email_taken: 'Sähköposti on jo rekisteröity.',
      bad_credentials: 'Väärä sähköpostiosoite tai salasana.',
      rate_limited: 'Liian monta yritystä – odota hetki ja yritä uudelleen.',
      invalid_input: 'Anna kelvollinen sähköpostiosoite ja vähintään 8 merkkiä pitkä salasana.',
      cancelled: 'Kirjautuminen peruttiin.',
      expired: 'Kirjautuminen kesti liian kauan – yritä uudelleen.',
      unverified_email: 'Google-tililläsi ei ole vahvistettua sähköpostiosoitetta.',
      account_link_required:
        'Tili tällä osoitteella on jo olemassa. Kirjaudu sisään sähköpostilla linkittääksesi Googlen.',
      email_verification_required:
        'Vahvista sähköpostiosoite erikseen ennen kyseisen Google-tilin käyttöä.',
      invalid_invite: 'Tämä kutsu on virheellinen, vanhentunut tai sitä on jo käytetty.',
      verification_expired:
        'Tämä vahvistuslinkki on virheellinen, vanhentunut tai sitä on jo käytetty.',
      verification_password_required:
        'Kirjoita rekisteröinnin yhteydessä valitsemasi salasana viimeistelläksesi tällä laitteella.',
      verification_wrong_password: 'Väärä salasana. Syötä rekisteröityessäsi valitsemasi salasana.',
      oauth_failed: 'Ei voitu kirjautua sisään Googlella. Yritä uudelleen.',
      oauth_unavailable: 'Google-sisäänkirjautuminen ei ole käytettävissä juuri nyt.',
      server_unavailable:
        'Palvelu ei ole tällä hetkellä käytettävissä. Yritä hetken kuluttua uudelleen.',
      logout_incomplete:
        'Tämä laite saattaa olla yhä kirjautuneena, kun sovellus käynnistyy uudelleen. Jos on, kirjaudu ulos uudelleen.',
      generic: 'Jotain meni pieleen. Yritä uudelleen.',
    },
  },
  fr: {
    tagline: 'AI made right',
    titleSignup: 'Créez votre compte',
    titleLogin: 'Bon retour',
    introSignup: 'Gardez vos discussions et obtenez un assistant qui se souvient de vous.',
    google: 'Continuer avec Google',
    divider: 'ou',
    showPassword: 'Afficher le mot de passe',
    hidePassword: 'Masquer le mot de passe',
    submitSignup: 'Créer un compte',
    submitLogin: 'Connectez-vous',
    switchToLoginPrefix: 'Vous avez déjà un compte ?',
    switchToLogin: 'Connectez-vous',
    switchToSignupPrefix: 'Vous êtes nouveau sur Poneva ?',
    switchToSignup: 'Créer un compte',
    close: 'Fermer',
    verificationTitle: 'Vérifiez votre boîte de réception',
    verificationBody: 'Nous avons envoyé un lien sécurisé à',
    verificationHint:
      'Ouvrez le lien e-mail pour créer votre compte – n’importe quel appareil fonctionne. Votre invitation attend en attendant.',
    verificationAgain: 'Utiliser une autre adresse e-mail',
    verifying: 'Vérification de votre email et création de votre compte…',
    confirmPasswordTitle: 'Confirmez votre mot de passe',
    confirmPasswordBody:
      'Votre email est vérifié. Vous avez ouvert le lien dans un autre navigateur, alors entrez le mot de passe que vous avez choisi pour créer votre compte et connectez-vous ici.',
    confirmPasswordPlaceholder: 'Votre mot de passe',
    confirmPasswordSubmit: 'Créez un compte et connectez-vous',
    errors: {
      email_taken: 'Cet e-mail est déjà enregistré.',
      bad_credentials: 'Mauvais email ou mot de passe.',
      rate_limited: 'Trop de tentatives : attendez un instant et réessayez.',
      invalid_input: "Saisissez un email valide et un mot de passe d'au moins 8 caractères.",
      cancelled: 'La connexion a été annulée.',
      expired: 'La connexion a pris trop de temps : veuillez réessayer.',
      unverified_email: "Votre compte Google n'a pas d'adresse e-mail vérifiée.",
      account_link_required:
        'Un compte avec cette adresse existe déjà. Connectez-vous avec votre adresse e-mail pour associer Google.',
      email_verification_required:
        "Vérifiez l'adresse e-mail séparément avant d'utiliser ce compte Google.",
      invalid_invite: "Cette invitation n'est pas valide, a expiré ou a déjà été utilisée.",
      verification_expired:
        "Ce lien de vérification n'est pas valide, a expiré ou a déjà été utilisé.",
      verification_password_required:
        "Saisissez le mot de passe que vous avez choisi lors de l'inscription pour terminer sur cet appareil.",
      verification_wrong_password:
        "Mauvais mot de passe. Entrez le mot de passe que vous avez choisi lors de l'inscription.",
      oauth_failed: 'Impossible de se connecter avec Google. Veuillez réessayer.',
      oauth_unavailable: "La connexion à Google n'est pas disponible pour le moment.",
      server_unavailable:
        "Le service n'est pas disponible pour le moment. Veuillez réessayer sous peu.",
      logout_incomplete:
        "Cet appareil est peut-être encore connecté au prochain démarrage de l'application. Si c'est le cas, déconnectez-vous à nouveau.",
      generic: "Quelque chose s'est mal passé. Veuillez réessayer.",
    },
  },
  de: {
    tagline: 'AI made right',
    titleSignup: 'Erstellen Sie Ihr Konto',
    titleLogin: 'Willkommen zurück',
    introSignup:
      'Behalten Sie Ihre Chats und holen Sie sich einen Assistenten, der sich an Sie erinnert.',
    google: 'Weiter mit Google',
    divider: 'oder',
    showPassword: 'Passwort anzeigen',
    hidePassword: 'Passwort verbergen',
    submitSignup: 'Konto erstellen',
    submitLogin: 'Melden Sie sich an',
    switchToLoginPrefix: 'Sie haben bereits ein Konto?',
    switchToLogin: 'Melden Sie sich an',
    switchToSignupPrefix: 'Neu bei Poneva?',
    switchToSignup: 'Konto erstellen',
    close: 'Schließen',
    verificationTitle: 'Überprüfen Sie Ihren Posteingang',
    verificationBody: 'Wir haben einen sicheren Link an gesendet',
    verificationHint:
      'Öffnen Sie den E-Mail-Link, um Ihr Konto zu erstellen – jedes Gerät funktioniert. Ihre Einladung wartet in der Zwischenzeit.',
    verificationAgain: 'Verwenden Sie eine andere E-Mail-Adresse',
    verifying: 'Überprüfen Sie Ihre E-Mail-Adresse und erstellen Sie Ihr Konto ...',
    confirmPasswordTitle: 'Bestätigen Sie Ihr Passwort',
    confirmPasswordBody:
      'Ihre E-Mail-Adresse ist bestätigt. Sie haben den Link in einem anderen Browser geöffnet. Geben Sie daher das Passwort ein, das Sie zum Erstellen Ihres Kontos gewählt haben, und melden Sie sich hier an.',
    confirmPasswordPlaceholder: 'Ihr Passwort',
    confirmPasswordSubmit: 'Konto erstellen und anmelden',
    errors: {
      email_taken: 'Diese E-Mail ist bereits registriert.',
      bad_credentials: 'Falsche E-Mail oder Passwort.',
      rate_limited: 'Zu viele Versuche – warten Sie einen Moment und versuchen Sie es erneut.',
      invalid_input:
        'Geben Sie eine gültige E-Mail-Adresse und ein Passwort mit mindestens 8 Zeichen ein.',
      cancelled: 'Die Anmeldung wurde abgebrochen.',
      expired: 'Die Anmeldung hat zu lange gedauert. Bitte versuchen Sie es erneut.',
      unverified_email: 'Ihr Google-Konto verfügt über keine bestätigte E-Mail-Adresse.',
      account_link_required:
        'Es existiert bereits ein Konto mit dieser Adresse. Melden Sie sich mit Ihrer E-Mail-Adresse an, um Google zu verknüpfen.',
      email_verification_required:
        'Überprüfen Sie die E-Mail-Adresse separat, bevor Sie dieses Google-Konto verwenden.',
      invalid_invite: 'Diese Einladung ist ungültig, abgelaufen oder wurde bereits verwendet.',
      verification_expired:
        'Dieser Bestätigungslink ist ungültig, abgelaufen oder wurde bereits verwendet.',
      verification_password_required:
        'Geben Sie das Passwort ein, das Sie bei der Anmeldung gewählt haben, um die Anmeldung auf diesem Gerät abzuschließen.',
      verification_wrong_password:
        'Falsches Passwort. Geben Sie das Passwort ein, das Sie bei der Anmeldung gewählt haben.',
      oauth_failed: 'Anmeldung bei Google nicht möglich. Bitte versuchen Sie es erneut.',
      oauth_unavailable: 'Die Google-Anmeldung ist derzeit nicht verfügbar.',
      server_unavailable:
        'Der Dienst ist derzeit nicht verfügbar. Bitte versuchen Sie es in Kürze noch einmal.',
      logout_incomplete:
        'Dieses Gerät ist beim nächsten Start der App möglicherweise noch angemeldet. Melden Sie sich in diesem Fall erneut ab.',
      generic: 'Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.',
    },
  },
  el: {
    tagline: 'AI made right',
    titleSignup: 'Δημιουργήστε τον λογαριασμό σας',
    titleLogin: 'Καλώς ήρθες πίσω',
    introSignup: 'Κρατήστε τις συνομιλίες σας και αποκτήστε έναν βοηθό που σας θυμάται.',
    google: 'Συνεχίστε με την Google',
    divider: 'ή',
    showPassword: 'Εμφάνιση κωδικού πρόσβασης',
    hidePassword: 'Απόκρυψη κωδικού πρόσβασης',
    submitSignup: 'Δημιουργία λογαριασμού',
    submitLogin: 'Συνδεθείτε',
    switchToLoginPrefix: 'Έχετε ήδη λογαριασμό;',
    switchToLogin: 'Συνδεθείτε',
    switchToSignupPrefix: 'Νέος στο Poneva;',
    switchToSignup: 'Δημιουργία λογαριασμού',
    close: 'Κλείσιμο',
    verificationTitle: 'Ελέγξτε τα εισερχόμενά σας',
    verificationBody: 'Στείλαμε έναν ασφαλή σύνδεσμο στο',
    verificationHint:
      'Ανοίξτε τον σύνδεσμο email για να δημιουργήσετε τον λογαριασμό σας — οποιαδήποτε συσκευή λειτουργεί. Η πρόσκλησή σας περιμένει στο μεταξύ.',
    verificationAgain: 'Χρησιμοποιήστε άλλη διεύθυνση email',
    verifying: 'Επαλήθευση του email σας και δημιουργία του λογαριασμού σας…',
    confirmPasswordTitle: 'Επιβεβαιώστε τον κωδικό πρόσβασής σας',
    confirmPasswordBody:
      'Το email σας έχει επαληθευτεί. Ανοίξατε τον σύνδεσμο σε διαφορετικό πρόγραμμα περιήγησης, επομένως εισαγάγετε τον κωδικό πρόσβασης που επιλέξατε για να δημιουργήσετε τον λογαριασμό σας και συνδεθείτε εδώ.',
    confirmPasswordPlaceholder: 'Ο κωδικός πρόσβασής σας',
    confirmPasswordSubmit: 'Δημιουργήστε λογαριασμό και συνδεθείτε',
    errors: {
      email_taken: 'Αυτό το email είναι ήδη καταχωρημένο.',
      bad_credentials: 'Λάθος email ή κωδικός πρόσβασης.',
      rate_limited: 'Πάρα πολλές προσπάθειες — περιμένετε λίγο και δοκιμάστε ξανά.',
      invalid_input:
        'Εισαγάγετε ένα έγκυρο email και έναν κωδικό πρόσβασης τουλάχιστον 8 χαρακτήρων.',
      cancelled: 'Η σύνδεση ακυρώθηκε.',
      expired: 'Η σύνδεση άργησε πολύ — δοκιμάστε ξανά.',
      unverified_email:
        'Ο λογαριασμός σας Google δεν έχει επαληθευμένη διεύθυνση ηλεκτρονικού ταχυδρομείου.',
      account_link_required:
        'Υπάρχει ήδη λογαριασμός με αυτήν τη διεύθυνση. Συνδεθείτε με email για να συνδέσετε το Google.',
      email_verification_required:
        'Επαληθεύστε τη διεύθυνση ηλεκτρονικού ταχυδρομείου ξεχωριστά πριν χρησιμοποιήσετε αυτόν τον λογαριασμό Google.',
      invalid_invite: 'Αυτή η πρόσκληση δεν είναι έγκυρη, έχει λήξει ή έχει ήδη χρησιμοποιηθεί.',
      verification_expired:
        'Αυτός ο σύνδεσμος επαλήθευσης δεν είναι έγκυρος, έχει λήξει ή έχει ήδη χρησιμοποιηθεί.',
      verification_password_required:
        'Εισαγάγετε τον κωδικό πρόσβασης που επιλέξατε κατά την εγγραφή για να ολοκληρώσετε σε αυτήν τη συσκευή.',
      verification_wrong_password:
        'Λάθος κωδικός πρόσβασης. Εισαγάγετε τον κωδικό πρόσβασης που επιλέξατε κατά την εγγραφή.',
      oauth_failed: 'Δεν ήταν δυνατή η σύνδεση με το Google. Δοκιμάστε ξανά.',
      oauth_unavailable: 'Η σύνδεση στο Google δεν είναι διαθέσιμη αυτήν τη στιγμή.',
      server_unavailable: 'Η υπηρεσία δεν είναι διαθέσιμη αυτήν τη στιγμή. Δοκιμάστε ξανά σύντομα.',
      logout_incomplete:
        'Αυτή η συσκευή μπορεί να είναι ακόμα συνδεδεμένη την επόμενη φορά που θα ανοίξει η εφαρμογή. Αν ναι, αποσυνδεθείτε ξανά.',
      generic: 'Κάτι πήγε στραβά. Δοκιμάστε ξανά.',
    },
  },
  hu: {
    tagline: 'AI made right',
    titleSignup: 'Hozd létre a fiókodat',
    titleLogin: 'Isten hozott újra',
    introSignup: 'Tartsa meg a csevegést, és szerezzen be egy asszisztenst, aki emlékszik rád.',
    google: 'Folytassa a Google-lal',
    divider: 'vagy',
    showPassword: 'Jelszó megjelenítése',
    hidePassword: 'Jelszó elrejtése',
    submitSignup: 'Hozzon létre fiókot',
    submitLogin: 'Jelentkezzen be',
    switchToLoginPrefix: 'Már van fiókja?',
    switchToLogin: 'Jelentkezzen be',
    switchToSignupPrefix: 'Új a Poneva?',
    switchToSignup: 'Hozzon létre fiókot',
    close: 'Bezárás',
    verificationTitle: 'Ellenőrizze a beérkező leveleket',
    verificationBody: 'Biztonságos linket küldtünk a címre',
    verificationHint:
      'Nyissa meg az e-mail hivatkozást a fiók létrehozásához – minden eszköz működik. Addig is vár a meghívása.',
    verificationAgain: 'Használjon másik e-mail címet',
    verifying: 'E-mail-cím ellenőrzése és fiók létrehozása…',
    confirmPasswordTitle: 'Erősítse meg jelszavát',
    confirmPasswordBody:
      'Az e-mail-címét ellenőriztük. A linket egy másik böngészőben nyitotta meg, ezért adja meg a fiók létrehozásához választott jelszót, és jelentkezzen be itt.',
    confirmPasswordPlaceholder: 'A jelszavad',
    confirmPasswordSubmit: 'Hozzon létre fiókot és jelentkezzen be',
    errors: {
      email_taken: 'Ez az e-mail már regisztrálva van.',
      bad_credentials: 'Hibás e-mail cím vagy jelszó.',
      rate_limited: 'Túl sok próbálkozás – várjon egy pillanatot, és próbálja újra.',
      invalid_input:
        'Adjon meg egy érvényes e-mail-címet és egy legalább 8 karakterből álló jelszót.',
      cancelled: 'A bejelentkezés megszakadt.',
      expired: 'A bejelentkezés túl sokáig tartott – kérjük, próbálja újra.',
      unverified_email: 'Google-fiókjának nincs ellenőrzött e-mail címe.',
      account_link_required:
        'Már létezik fiók ezzel a címmel. Jelentkezzen be e-mail-címmel a Google összekapcsolásához.',
      email_verification_required: 'A Google-fiók használata előtt külön igazolja az e-mail címet.',
      invalid_invite: 'A meghívás érvénytelen, lejárt vagy már felhasználták.',
      verification_expired: 'Az ellenőrző link érvénytelen, lejárt vagy már használták.',
      verification_password_required:
        'Az eszközön való befejezéshez adja meg a regisztrációkor választott jelszót.',
      verification_wrong_password: 'Hibás jelszó. Adja meg a regisztrációkor választott jelszót.',
      oauth_failed: 'Nem sikerült bejelentkezni a Google-lal. Kérjük, próbálja újra.',
      oauth_unavailable: 'A Google bejelentkezés jelenleg nem érhető el.',
      server_unavailable:
        'A szolgáltatás jelenleg nem elérhető. Kérjük, rövid időn belül próbálja újra.',
      logout_incomplete:
        'Előfordulhat, hogy ez az eszköz az alkalmazás következő indításakor még be van jelentkezve. Ha így van, jelentkezzen ki újra.',
      generic: 'Valami elromlott. Kérjük, próbálja újra.',
    },
  },
  ga: {
    tagline: 'AI made right',
    titleSignup: 'Cruthaigh do chuntas',
    titleLogin: 'Fáilte ar ais',
    introSignup: 'Coinnigh do chuid comhráite agus faigh cúntóir a cuimhin leat.',
    google: 'Lean ar aghaidh le Google',
    divider: 'nó',
    showPassword: 'Taispeáin an pasfhocal',
    hidePassword: 'Folaigh an pasfhocal',
    submitSignup: 'Cruthaigh cuntas',
    submitLogin: 'Logáil isteach',
    switchToLoginPrefix: 'An bhfuil cuntas agat cheana féin?',
    switchToLogin: 'Logáil isteach',
    switchToSignupPrefix: 'Nua i Poneva?',
    switchToSignup: 'Cruthaigh cuntas',
    close: 'Dún',
    verificationTitle: 'Seiceáil do bhosca isteach',
    verificationBody: 'Sheolamar nasc slán chuig',
    verificationHint:
      'Oscail an nasc ríomhphoist chun do chuntas a chruthú - oibríonn gléas ar bith. Fanann do chuireadh idir an dá linn.',
    verificationAgain: 'Úsáid seoladh ríomhphoist eile',
    verifying: 'do ríomhphost á fhíorú agus do chuntas á chruthú…',
    confirmPasswordTitle: 'Deimhnigh do phasfhocal',
    confirmPasswordBody:
      'Tá do ríomhphost fíoraithe. D’oscail tú an nasc i mbrabhsálaí eile, mar sin cuir isteach an pasfhocal a roghnaigh tú chun do chuntas a chruthú agus sínigh isteach anseo.',
    confirmPasswordPlaceholder: 'Do phasfhocal',
    confirmPasswordSubmit: 'Cruthaigh cuntas agus sínigh isteach',
    errors: {
      email_taken: 'Tá an ríomhphost sin cláraithe cheana féin.',
      bad_credentials: 'Ríomhphost nó pasfhocal mícheart.',
      rate_limited: 'An iomarca iarrachtaí - fan nóiméad agus bain triail eile as.',
      invalid_input: 'Cuir isteach ríomhphost bailí agus pasfhocal de 8 gcarachtar ar a laghad.',
      cancelled: 'Cuireadh an síniú isteach ar ceal.',
      expired: 'Thóg an síniú isteach ró-fhada - bain triail eile as.',
      unverified_email: 'Níl aon seoladh ríomhphoist fíoraithe ag do Chuntas Google.',
      account_link_required:
        'Tá cuntas leis an seoladh sin ann cheana. Sínigh isteach le ríomhphost chun Google a nascadh.',
      email_verification_required:
        'Fíoraigh an seoladh ríomhphoist ar leithligh roimh úsáid a bhaint as an gcuntas Google sin.',
      invalid_invite: 'Tá an cuireadh sin neamhbhailí, imithe in éag, nó tá sé in úsáid cheana.',
      verification_expired:
        'Tá an nasc fíorúcháin sin neamhbhailí, imithe in éag, nó úsáideadh cheana.',
      verification_password_required:
        'Cuir isteach an pasfhocal a roghnaigh tú ag clárú le críochnú ar an ngléas seo.',
      verification_wrong_password:
        'Focal faire mícheart. Cuir isteach an pasfhocal a roghnaigh tú ag síniú.',
      oauth_failed: 'Níorbh fhéidir síniú isteach le Google. Bain triail eile as.',
      oauth_unavailable: 'Níl síniú isteach Google ar fáil faoi láthair.',
      server_unavailable: 'Níl an tseirbhís ar fáil faoi láthair. Bain triail eile as gan mhoill.',
      logout_incomplete:
        'Seans go mbeidh an gléas seo logáilte isteach fós nuair a thosóidh an aip arís. Más ea, logáil amach arís.',
      generic: 'Chuaigh rud éigin mícheart. Bain triail eile as.',
    },
  },
  it: {
    tagline: 'AI made right',
    titleSignup: 'Crea il tuo account',
    titleLogin: 'Bentornato',
    introSignup: 'Conserva le tue chat e ottieni un assistente che si ricordi di te.',
    google: 'Continua con Google',
    divider: 'o',
    showPassword: 'Mostra password',
    hidePassword: 'Nascondi password',
    submitSignup: 'Crea un account',
    submitLogin: 'Accedi',
    switchToLoginPrefix: 'Hai già un account?',
    switchToLogin: 'Accedi',
    switchToSignupPrefix: 'Nuovo a Poneva?',
    switchToSignup: 'Crea un account',
    close: 'Chiudi',
    verificationTitle: 'Controlla la tua casella di posta',
    verificationBody: 'Abbiamo inviato un collegamento sicuro a',
    verificationHint:
      'Apri il collegamento e-mail per creare il tuo account: qualsiasi dispositivo funziona. Il tuo invito attende nel frattempo.',
    verificationAgain: 'Utilizza un altro indirizzo email',
    verifying: 'Verifica la tua email e creazione del tuo account…',
    confirmPasswordTitle: 'Conferma la tua password',
    confirmPasswordBody:
      'La tua email è verificata. Hai aperto il collegamento in un browser diverso, quindi inserisci la password che hai scelto per creare il tuo account e accedi qui.',
    confirmPasswordPlaceholder: 'La tua password',
    confirmPasswordSubmit: 'Crea un account e accedi',
    errors: {
      email_taken: 'Quella email è già registrata.',
      bad_credentials: 'Email o password sbagliata.',
      rate_limited: 'Troppi tentativi: aspetta un attimo e riprova.',
      invalid_input: 'Inserisci una email valida e una password di almeno 8 caratteri.',
      cancelled: "L'accesso è stato annullato.",
      expired: "L'accesso ha richiesto troppo tempo: riprova.",
      unverified_email: 'Il tuo Account Google non ha un indirizzo email verificato.',
      account_link_required:
        "Esiste già un account con quell'indirizzo. Accedi con l'e-mail per collegare Google.",
      email_verification_required:
        "Verifica l'indirizzo email separatamente prima di utilizzare quell'account Google.",
      invalid_invite: "L'invito non è valido, è scaduto o è già stato utilizzato.",
      verification_expired: 'Il link di verifica non è valido, è scaduto o è già stato utilizzato.',
      verification_password_required:
        "Inserisci la password che hai scelto al momento della registrazione per completare l'operazione su questo dispositivo.",
      verification_wrong_password:
        'Password errata. Inserisci la password che hai scelto al momento della registrazione.',
      oauth_failed: 'Impossibile accedere con Google. Per favore riprova.',
      oauth_unavailable: "L'accesso a Google non è disponibile al momento.",
      server_unavailable: 'Il servizio non è disponibile al momento. Per favore riprova a breve.',
      logout_incomplete:
        "Questo dispositivo potrebbe risultare ancora connesso al prossimo avvio dell'app. In tal caso, esci di nuovo.",
      generic: 'Qualcosa è andato storto. Per favore riprova.',
    },
  },
  lv: {
    tagline: 'AI made right',
    titleSignup: 'Izveidojiet savu kontu',
    titleLogin: 'Laipni lūdzam atpakaļ',
    introSignup: 'Saglabājiet tērzēšanu un iegūstiet palīgu, kas jūs atceras.',
    google: 'Turpiniet ar Google',
    divider: 'vai',
    showPassword: 'Rādīt paroli',
    hidePassword: 'Paslēpt paroli',
    submitSignup: 'Izveidot kontu',
    submitLogin: 'Piesakieties',
    switchToLoginPrefix: 'Vai jums jau ir konts?',
    switchToLogin: 'Piesakieties',
    switchToSignupPrefix: 'Vai esat jauns ponevā?',
    switchToSignup: 'Izveidot kontu',
    close: 'Aizvērt',
    verificationTitle: 'Pārbaudiet savu iesūtni',
    verificationBody: 'Mēs nosūtījām drošu saiti uz',
    verificationHint:
      'Atveriet e-pasta saiti, lai izveidotu kontu — darbojas jebkura ierīce. Tikmēr tiek gaidīts jūsu ielūgums.',
    verificationAgain: 'Izmantojiet citu e-pasta adresi',
    verifying: 'Notiek jūsu e-pasta apstiprināšana un konta izveide…',
    confirmPasswordTitle: 'Apstipriniet savu paroli',
    confirmPasswordBody:
      'Jūsu e-pasts ir pārbaudīts. Jūs atvērāt saiti citā pārlūkprogrammā, tāpēc ievadiet paroli, kuru izvēlējāties, lai izveidotu kontu, un pierakstieties šeit.',
    confirmPasswordPlaceholder: 'Jūsu parole',
    confirmPasswordSubmit: 'Izveidojiet kontu un pierakstieties',
    errors: {
      email_taken: 'Šis e-pasts jau ir reģistrēts.',
      bad_credentials: 'Nepareizs e-pasts vai parole.',
      rate_limited: 'Pārāk daudz mēģinājumu — uzgaidiet un mēģiniet vēlreiz.',
      invalid_input: 'Ievadiet derīgu e-pasta adresi un paroli, kas ir vismaz 8 rakstzīmes.',
      cancelled: 'Pierakstīšanās tika atcelta.',
      expired: 'Pierakstīšanās aizņēma pārāk ilgu laiku — lūdzu, mēģiniet vēlreiz.',
      unverified_email: 'Jūsu Google kontam nav verificētas e-pasta adreses.',
      account_link_required:
        'Konts ar šo adresi jau pastāv. Pierakstieties ar e-pastu, lai saistītu Google.',
      email_verification_required:
        'Pirms šī Google konta izmantošanas atsevišķi verificējiet e-pasta adresi.',
      invalid_invite:
        'Šis uzaicinājums ir nederīgs, beidzies derīguma termiņš vai tas jau ir izmantots.',
      verification_expired:
        'Šī verifikācijas saite nav derīga, tai ir beidzies derīguma termiņš vai tā jau ir izmantota.',
      verification_password_required:
        'Ievadiet paroli, kuru izvēlējāties reģistrējoties, lai pabeigtu darbību šajā ierīcē.',
      verification_wrong_password:
        'Nepareiza parole. Ievadiet paroli, kuru izvēlējāties reģistrējoties.',
      oauth_failed: 'Nevarēja pierakstīties ar Google. Lūdzu, mēģiniet vēlreiz.',
      oauth_unavailable: 'Google pierakstīšanās pašlaik nav pieejama.',
      server_unavailable: 'Pakalpojums šobrīd nav pieejams. Lūdzu, drīzumā mēģiniet vēlreiz.',
      logout_incomplete:
        'Šī ierīce, iespējams, joprojām būs pierakstīta, kad lietotne tiks atvērta vēlreiz. Ja tā ir, atsakieties vēlreiz.',
      generic: 'Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.',
    },
  },
  lt: {
    tagline: 'AI made right',
    titleSignup: 'Susikurkite paskyrą',
    titleLogin: 'Sveiki sugrįžę',
    introSignup: 'Palaikykite pokalbius ir gaukite asistentą, kuris jus prisimins.',
    google: 'Tęskite su Google',
    divider: 'arba',
    showPassword: 'Rodyti slaptažodį',
    hidePassword: 'Slėpti slaptažodį',
    submitSignup: 'Sukurti paskyrą',
    submitLogin: 'Prisijunkite',
    switchToLoginPrefix: 'Jau turite paskyrą?',
    switchToLogin: 'Prisijunkite',
    switchToSignupPrefix: 'Naujas „Poneva“ naudotojas?',
    switchToSignup: 'Sukurti paskyrą',
    close: 'Uždaryti',
    verificationTitle: 'Patikrinkite gautuosius',
    verificationBody: 'Išsiuntėme saugią nuorodą',
    verificationHint:
      'Atidarykite el. pašto nuorodą, kad sukurtumėte paskyrą – veikia bet kuris įrenginys. Tuo tarpu jūsų kvietimas laukia.',
    verificationAgain: 'Naudokite kitą el. pašto adresą',
    verifying: 'Patvirtinamas el. paštas ir sukuriama paskyra…',
    confirmPasswordTitle: 'Patvirtinkite slaptažodį',
    confirmPasswordBody:
      'Jūsų el. paštas patvirtintas. Nuorodą atidarėte kitoje naršyklėje, todėl įveskite slaptažodį, kurį pasirinkote kurdami paskyrą, ir prisijunkite čia.',
    confirmPasswordPlaceholder: 'Jūsų slaptažodis',
    confirmPasswordSubmit: 'Sukurkite paskyrą ir prisijunkite',
    errors: {
      email_taken: 'Tas el. paštas jau užregistruotas.',
      bad_credentials: 'Neteisingas el. pašto adresas arba slaptažodis.',
      rate_limited: 'Per daug bandymų – palaukite ir bandykite dar kartą.',
      invalid_input: 'Įveskite galiojantį el. pašto adresą ir bent 8 simbolių slaptažodį.',
      cancelled: 'Prisijungimas buvo atšauktas.',
      expired: 'Prisijungimas užtruko per ilgai – bandykite dar kartą.',
      unverified_email: 'Jūsų „Google“ paskyroje nėra patvirtinto el. pašto adreso.',
      account_link_required:
        'Paskyra šiuo adresu jau yra. Prisijunkite naudodami el. pašto adresą, kad susietumėte „Google“.',
      email_verification_required:
        'Prieš naudodami tą „Google“ paskyrą atskirai patvirtinkite el. pašto adresą.',
      invalid_invite: 'Tas kvietimas netinkamas, pasibaigęs arba jau panaudotas.',
      verification_expired: 'Ta patvirtinimo nuoroda netinkama, pasibaigė arba jau buvo panaudota.',
      verification_password_required:
        'Įveskite slaptažodį, kurį pasirinkote prisiregistruodami, kad užbaigtumėte šiame įrenginyje.',
      verification_wrong_password:
        'Neteisingas slaptažodis. Įveskite slaptažodį, kurį pasirinkote registruodamiesi.',
      oauth_failed: 'Nepavyko prisijungti naudojant „Google“. Bandykite dar kartą.',
      oauth_unavailable: '„Google“ prisijungimas šiuo metu nepasiekiamas.',
      server_unavailable: 'Paslauga šiuo metu nepasiekiama. Netrukus bandykite dar kartą.',
      logout_incomplete:
        'Kitą kartą paleidus programėlę, šis įrenginys gali likti prisijungęs. Jei taip, atsijunkite dar kartą.',
      generic: 'Kažkas nutiko. Bandykite dar kartą.',
    },
  },
  mt: {
    tagline: 'AI made right',
    titleSignup: 'Oħloq il-kont tiegħek',
    titleLogin: 'Merħba lura',
    introSignup: 'Żomm iċ-chats tiegħek u ġib assistent li jiftakarek.',
    google: 'Kompli bil-Google',
    divider: 'jew',
    showPassword: 'Uri l-password',
    hidePassword: 'Aħbi l-password',
    submitSignup: 'Oħloq kont',
    submitLogin: 'Idħol',
    switchToLoginPrefix: 'Diġà għandek kont?',
    switchToLogin: 'Idħol',
    switchToSignupPrefix: 'Ġdid għal Poneva?',
    switchToSignup: 'Oħloq kont',
    close: 'Agħlaq',
    verificationTitle: 'Iċċekkja l-inbox tiegħek',
    verificationBody: 'Bgħatna link sigur lil',
    verificationHint:
      'Iftaħ il-link tal-email biex toħloq il-kont tiegħek — kwalunkwe apparat jaħdem. L-istedina tiegħek tistenna fil-frattemp.',
    verificationAgain: 'Uża indirizz elettroniku ieħor',
    verifying: 'Tivverifika l-email tiegħek u qed toħloq il-kont tiegħek...',
    confirmPasswordTitle: 'Ikkonferma l-password tiegħek',
    confirmPasswordBody:
      "L-email tiegħek hija vverifikata. Ftaħt il-link f'browser differenti, għalhekk daħħal il-password li għażilt biex toħloq il-kont tiegħek u idħol hawn.",
    confirmPasswordPlaceholder: 'Il-password tiegħek',
    confirmPasswordSubmit: 'Oħloq kont u idħol',
    errors: {
      email_taken: 'Dik l-email hija diġà rreġistrata.',
      bad_credentials: 'Email jew password ħażina.',
      rate_limited: "Wisq tentattivi — stenna ftit u erġa' pprova.",
      invalid_input: "Daħħal email valida u password ta' mill-inqas 8 karattri.",
      cancelled: 'Id-dħul ġie kkanċellat.',
      expired: "Id-dħul dam wisq — jekk jogħġbok erġa' pprova.",
      unverified_email: "Il-kont Google tiegħek m'għandu l-ebda indirizz elettroniku vverifikat.",
      account_link_required:
        "Kont b'dak l-indirizz diġà jeżisti. Idħol bl-email biex torbot lil Google.",
      email_verification_required:
        'Ivverifika l-indirizz tal-email separatament qabel tuża dak il-kont Google.',
      invalid_invite: 'Dik l-istedina hija invalida, skadiet, jew diġà ntużat.',
      verification_expired: "Dik il-link ta' verifika hija invalida, skadiet, jew diġà ntużat.",
      verification_password_required:
        'Daħħal il-password li għażilt meta tirreġistra biex tispiċċa fuq dan l-apparat.',
      verification_wrong_password:
        'Password ħażina. Daħħal il-password li għażilt meta tirreġistra.',
      oauth_failed: "Ma setgħetx tidħol ma' Google. Jekk jogħġbok erġa' pprova.",
      oauth_unavailable: 'Id-dħul fil-Google mhuwiex disponibbli bħalissa.',
      server_unavailable:
        "Is-servizz mhux disponibbli bħalissa. Jekk jogħġbok erġa' pprova dalwaqt.",
      logout_incomplete:
        "Dan l-apparat jista' jibqa' dieħel meta l-app terġa' tibda. Jekk iva, erġa' agħmel log out.",
      generic: "Xi ħaġa marret ħażin. Jekk jogħġbok erġa' pprova.",
    },
  },
  pl: {
    tagline: 'AI made right',
    titleSignup: 'Utwórz swoje konto',
    titleLogin: 'Witamy z powrotem',
    introSignup: 'Zachowaj swoje czaty i uzyskaj asystenta, który Cię pamięta.',
    google: 'Kontynuuj z Google',
    divider: 'lub',
    showPassword: 'Pokaż hasło',
    hidePassword: 'Ukryj hasło',
    submitSignup: 'Utwórz konto',
    submitLogin: 'Zaloguj się',
    switchToLoginPrefix: 'Masz już konto?',
    switchToLogin: 'Zaloguj się',
    switchToSignupPrefix: 'Nowy w Ponevie?',
    switchToSignup: 'Utwórz konto',
    close: 'Zamknij',
    verificationTitle: 'Sprawdź swoją skrzynkę odbiorczą',
    verificationBody: 'Wysłaliśmy bezpieczny link do',
    verificationHint:
      'Otwórz link e-mail, aby utworzyć konto — działa na każdym urządzeniu. Twoje zaproszenie oczekuje w międzyczasie.',
    verificationAgain: 'Użyj innego adresu e-mail',
    verifying: 'Weryfikacja adresu e-mail i tworzenie konta…',
    confirmPasswordTitle: 'Potwierdź swoje hasło',
    confirmPasswordBody:
      'Twój e-mail został zweryfikowany. Otworzyłeś link w innej przeglądarce, więc wpisz hasło wybrane do założenia konta i zaloguj się tutaj.',
    confirmPasswordPlaceholder: 'Twoje hasło',
    confirmPasswordSubmit: 'Utwórz konto i zaloguj się',
    errors: {
      email_taken: 'Ten adres e-mail jest już zarejestrowany.',
      bad_credentials: 'Zły adres e-mail lub hasło.',
      rate_limited: 'Zbyt wiele prób — poczekaj chwilę i spróbuj ponownie.',
      invalid_input: 'Wpisz prawidłowy adres e-mail i hasło składające się z co najmniej 8 znaków.',
      cancelled: 'Logowanie zostało anulowane.',
      expired: 'Logowanie trwało zbyt długo — spróbuj ponownie.',
      unverified_email: 'Twoje konto Google nie ma zweryfikowanego adresu e-mail.',
      account_link_required:
        'Konto o tym adresie już istnieje. Zaloguj się za pomocą adresu e-mail, aby połączyć Google.',
      email_verification_required:
        'Przed użyciem tego konta Google zweryfikuj adres e-mail osobno.',
      invalid_invite: 'To zaproszenie jest nieprawidłowe, wygasło lub zostało już wykorzystane.',
      verification_expired:
        'Ten link weryfikacyjny jest nieprawidłowy, wygasł lub został już użyty.',
      verification_password_required:
        'Wprowadź hasło wybrane podczas rejestracji, aby zakończyć na tym urządzeniu.',
      verification_wrong_password: 'Błędne hasło. Wpisz hasło wybrane podczas rejestracji.',
      oauth_failed: 'Nie można zalogować się za pomocą Google. Spróbuj ponownie.',
      oauth_unavailable: 'Logowanie przez Google nie jest obecnie dostępne.',
      server_unavailable: 'Usługa jest obecnie niedostępna. Spróbuj ponownie wkrótce.',
      logout_incomplete:
        'To urządzenie może być nadal zalogowane po ponownym uruchomieniu aplikacji. Jeśli tak, wyloguj się ponownie.',
      generic: 'Coś poszło nie tak. Spróbuj ponownie.',
    },
  },
  pt: {
    tagline: 'AI made right',
    titleSignup: 'Crie a sua conta',
    titleLogin: 'Bem-vindo de volta',
    introSignup: 'Guarde as suas conversas e tenha um assistente que se lembra de si.',
    google: 'Continuar com o Google',
    divider: 'ou',
    showPassword: 'Mostrar palavra-passe',
    hidePassword: 'Ocultar palavra-passe',
    submitSignup: 'Criar conta',
    submitLogin: 'Iniciar sessão',
    switchToLoginPrefix: 'Já tem uma conta?',
    switchToLogin: 'Iniciar sessão',
    switchToSignupPrefix: 'Novo no Poneva?',
    switchToSignup: 'Criar conta',
    close: 'Fechar',
    verificationTitle: 'Consulte a sua caixa de entrada',
    verificationBody: 'Enviamos um link seguro para',
    verificationHint:
      'Abra o link do e-mail para criar a sua conta — pode fazê-lo em qualquer dispositivo. Entretanto, o seu convite fica reservado.',
    verificationAgain: 'Utilizar outro endereço de e-mail',
    verifying: 'A verificar o seu e-mail e a criar a sua conta…',
    confirmPasswordTitle: 'Confirme a sua palavra-passe',
    confirmPasswordBody:
      'O seu e-mail foi verificado. Abriu o link noutro navegador; introduza a palavra-passe que escolheu para criar a conta e iniciar sessão aqui.',
    confirmPasswordPlaceholder: 'A sua palavra-passe',
    confirmPasswordSubmit: 'Criar conta e iniciar sessão',
    errors: {
      email_taken: 'Esse e-mail já está registado.',
      bad_credentials: 'E-mail ou palavra-passe incorretos.',
      rate_limited: 'Demasiadas tentativas — aguarde um momento e tente novamente.',
      invalid_input: 'Introduza um e-mail válido e uma palavra-passe com pelo menos 8 caracteres.',
      cancelled: 'O início de sessão foi cancelado.',
      expired: 'O início de sessão demorou demasiado tempo — tente novamente.',
      unverified_email: 'A sua conta Google não tem um endereço de e-mail verificado.',
      account_link_required:
        'Já existe uma conta com esse endereço. Inicie sessão por e-mail para associar o Google.',
      email_verification_required:
        'Verifique o endereço de e-mail separadamente antes de utilizar essa conta Google.',
      invalid_invite: 'Esse convite é inválido, expirou ou já foi utilizado.',
      verification_expired: 'Esse link de verificação é inválido, expirou ou já foi utilizado.',
      verification_password_required:
        'Introduza a palavra-passe que escolheu no registo para concluir neste dispositivo.',
      verification_wrong_password:
        'Palavra-passe incorreta. Introduza a palavra-passe que escolheu no registo.',
      oauth_failed: 'Não foi possível iniciar sessão com o Google. Tente novamente.',
      oauth_unavailable: 'O início de sessão com o Google não está disponível de momento.',
      server_unavailable:
        'O serviço não está disponível de momento. Tente novamente dentro de instantes.',
      logout_incomplete:
        'Este dispositivo poderá continuar com sessão iniciada quando a aplicação voltar a abrir. Se for o caso, saia novamente.',
      generic: 'Ocorreu um erro. Tente novamente.',
    },
  },
  ro: {
    tagline: 'AI made right',
    titleSignup: 'Creați-vă contul',
    titleLogin: 'Bine ai revenit',
    introSignup: 'Păstrează-ți conversațiile și obține un asistent care să te amintească.',
    google: 'Continuați cu Google',
    divider: 'sau',
    showPassword: 'Afișează parola',
    hidePassword: 'Ascunde parola',
    submitSignup: 'Creați cont',
    submitLogin: 'Conectați-vă',
    switchToLoginPrefix: 'Aveți deja un cont?',
    switchToLogin: 'Conectați-vă',
    switchToSignupPrefix: 'Nou la Poneva?',
    switchToSignup: 'Creați cont',
    close: 'Închide',
    verificationTitle: 'Verificați-vă căsuța de e-mail',
    verificationBody: 'Am trimis un link securizat către',
    verificationHint:
      'Deschideți linkul de e-mail pentru a vă crea contul - orice dispozitiv funcționează. Invitația ta așteaptă între timp.',
    verificationAgain: 'Folosiți o altă adresă de e-mail',
    verifying: 'Se verifică adresa de e-mail și se creează contul...',
    confirmPasswordTitle: 'Confirmați-vă parola',
    confirmPasswordBody:
      'E-mailul dvs. este verificat. Ați deschis linkul într-un browser diferit, așa că introduceți parola pe care ați ales-o pentru a vă crea contul și conectați-vă aici.',
    confirmPasswordPlaceholder: 'Parola dvs',
    confirmPasswordSubmit: 'Creează cont și conectează-te',
    errors: {
      email_taken: 'Acel e-mail este deja înregistrat.',
      bad_credentials: 'E-mail sau parolă greșită.',
      rate_limited: 'Prea multe încercări — așteptați un moment și încercați din nou.',
      invalid_input: 'Introduceți un e-mail valid și o parolă de cel puțin 8 caractere.',
      cancelled: 'Conectarea a fost anulată.',
      expired: 'Conectarea a durat prea mult. Încercați din nou.',
      unverified_email: 'Contul dvs. Google nu are o adresă de e-mail verificată.',
      account_link_required:
        'Un cont cu acea adresă există deja. Conectați-vă cu e-mail pentru a conecta Google.',
      email_verification_required:
        'Verificați separat adresa de e-mail înainte de a utiliza acel cont Google.',
      invalid_invite: 'Acea invitație este nevalidă, a expirat sau a fost deja folosită.',
      verification_expired: 'Linkul de verificare este nevalid, a expirat sau a fost deja folosit.',
      verification_password_required:
        'Introduceți parola pe care ați ales-o la înregistrare pentru a finaliza pe acest dispozitiv.',
      verification_wrong_password:
        'Parolă greșită. Introduceți parola pe care ați ales-o la înregistrare.',
      oauth_failed: 'Nu s-a putut conecta cu Google. Vă rugăm să încercați din nou.',
      oauth_unavailable: 'Conectarea la Google nu este disponibilă momentan.',
      server_unavailable:
        'Serviciul nu este disponibil momentan. Vă rugăm să încercați din nou în scurt timp.',
      logout_incomplete:
        'Este posibil ca acest dispozitiv să fie încă conectat la următoarea pornire a aplicației. În acest caz, deconectați-vă din nou.',
      generic: 'Ceva a mers prost. Vă rugăm să încercați din nou.',
    },
  },
  sk: {
    tagline: 'AI made right',
    titleSignup: 'Vytvorte si účet',
    titleLogin: 'Vitajte späť',
    introSignup: 'Udržujte svoje rozhovory a získajte asistenta, ktorý si vás zapamätá.',
    google: 'Pokračujte v službe Google',
    divider: 'alebo',
    showPassword: 'Zobraziť heslo',
    hidePassword: 'Skryť heslo',
    submitSignup: 'Vytvoriť účet',
    submitLogin: 'Prihláste sa',
    switchToLoginPrefix: 'Už máte účet?',
    switchToLogin: 'Prihláste sa',
    switchToSignupPrefix: 'Ste novým používateľom Poneva?',
    switchToSignup: 'Vytvoriť účet',
    close: 'Zavrieť',
    verificationTitle: 'Skontrolujte si doručenú poštu',
    verificationBody: 'Poslali sme zabezpečený odkaz na',
    verificationHint:
      'Otvorte e-mailový odkaz a vytvorte si účet – funguje každé zariadenie. Vaše pozvanie medzitým čaká.',
    verificationAgain: 'Použite inú e-mailovú adresu',
    verifying: 'Overuje sa váš e-mail a vytvára sa účet…',
    confirmPasswordTitle: 'Potvrďte svoje heslo',
    confirmPasswordBody:
      'Váš email je overený. Odkaz ste otvorili v inom prehliadači, takže zadajte heslo, ktoré ste si vybrali na vytvorenie účtu, a prihláste sa tu.',
    confirmPasswordPlaceholder: 'Vaše heslo',
    confirmPasswordSubmit: 'Vytvorte si účet a prihláste sa',
    errors: {
      email_taken: 'Tento e-mail je už zaregistrovaný.',
      bad_credentials: 'Nesprávny e-mail alebo heslo.',
      rate_limited: 'Príliš veľa pokusov – chvíľu počkajte a skúste to znova.',
      invalid_input: 'Zadajte platný email a heslo s minimálne 8 znakmi.',
      cancelled: 'Prihlásenie bolo zrušené.',
      expired: 'Prihlásenie trvalo príliš dlho – skúste to znova.',
      unverified_email: 'Váš účet Google nemá overenú e-mailovú adresu.',
      account_link_required:
        'Účet s touto adresou už existuje. Ak chcete prepojiť Google, prihláste sa pomocou e-mailu.',
      email_verification_required:
        'Pred použitím daného účtu Google samostatne overte e-mailovú adresu.',
      invalid_invite: 'Táto pozvánka je neplatná, jej platnosť vypršala alebo už bola použitá.',
      verification_expired:
        'Tento overovací odkaz je neplatný, jeho platnosť vypršala alebo už bol použitý.',
      verification_password_required:
        'Zadajte heslo, ktoré ste si vybrali pri registrácii, aby ste dokončili prácu na tomto zariadení.',
      verification_wrong_password:
        'Nesprávne heslo. Zadajte heslo, ktoré ste si zvolili pri registrácii.',
      oauth_failed: 'Nepodarilo sa prihlásiť cez Google. Skúste to znova.',
      oauth_unavailable: 'Prihlásenie cez Google nie je momentálne dostupné.',
      server_unavailable: 'Služba je momentálne nedostupná. Skúste to znova o chvíľu.',
      logout_incomplete:
        'Toto zariadenie môže byť po ďalšom spustení aplikácie stále prihlásené. Ak áno, odhláste sa znova.',
      generic: 'Niečo sa pokazilo. Skúste to znova.',
    },
  },
  sl: {
    tagline: 'AI made right',
    titleSignup: 'Ustvarite svoj račun',
    titleLogin: 'dobrodošli nazaj',
    introSignup: 'Ohranite svoje klepete in pridobite pomočnika, ki si vas zapomni.',
    google: 'Nadaljujte z Googlom',
    divider: 'oz',
    showPassword: 'Pokaži geslo',
    hidePassword: 'Skrij geslo',
    submitSignup: 'Ustvari račun',
    submitLogin: 'Prijavite se',
    switchToLoginPrefix: 'Že imate račun?',
    switchToLogin: 'Prijavite se',
    switchToSignupPrefix: 'Ste novi pri Poneva?',
    switchToSignup: 'Ustvari račun',
    close: 'Zapri',
    verificationTitle: 'Preverite svoj nabiralnik',
    verificationBody: 'Poslali smo varno povezavo na',
    verificationHint:
      'Odprite e-poštno povezavo, da ustvarite svoj račun - katera koli naprava deluje. Vaše povabilo medtem čaka.',
    verificationAgain: 'Uporabite drug e-poštni naslov',
    verifying: 'Preverjanje e-pošte in ustvarjanje računa …',
    confirmPasswordTitle: 'Potrdite svoje geslo',
    confirmPasswordBody:
      'Vaš e-poštni naslov je preverjen. Povezavo ste odprli v drugem brskalniku, zato vnesite geslo, ki ste ga izbrali za ustvarjanje računa, in se prijavite tukaj.',
    confirmPasswordPlaceholder: 'Vaše geslo',
    confirmPasswordSubmit: 'Ustvarite račun in se prijavite',
    errors: {
      email_taken: 'Ta e-pošta je že registrirana.',
      bad_credentials: 'Napačen e-poštni naslov ali geslo.',
      rate_limited: 'Preveč poskusov — počakajte trenutek in poskusite znova.',
      invalid_input: 'Vnesite veljaven e-poštni naslov in geslo z vsaj 8 znaki.',
      cancelled: 'Prijava je bila preklicana.',
      expired: 'Prijava je trajala predolgo — poskusite znova.',
      unverified_email: 'Vaš račun Google nima potrjenega e-poštnega naslova.',
      account_link_required:
        'Račun s tem naslovom že obstaja. Prijavite se z e-pošto, da povežete Google.',
      email_verification_required:
        'Pred uporabo tega Google računa posebej preverite e-poštni naslov.',
      invalid_invite: 'To povabilo je neveljavno, je poteklo ali je bilo že uporabljeno.',
      verification_expired:
        'Ta povezava za preverjanje ni veljavna, je potekla ali je že bila uporabljena.',
      verification_password_required:
        'Vnesite geslo, ki ste ga izbrali ob prijavi, da končate v tej napravi.',
      verification_wrong_password: 'Napačno geslo. Vnesite geslo, ki ste ga izbrali ob prijavi.',
      oauth_failed: 'Ni bilo mogoče prijaviti z Googlom. prosim poskusite ponovno',
      oauth_unavailable: 'Prijava v Google trenutno ni na voljo.',
      server_unavailable: 'Storitev trenutno ni na voljo. Poskusite znova kmalu.',
      logout_incomplete:
        'Ta naprava je lahko ob naslednjem zagonu aplikacije še vedno prijavljena. V tem primeru se znova odjavite.',
      generic: 'Nekaj je šlo narobe. prosim poskusite ponovno',
    },
  },
  es: {
    tagline: 'AI made right',
    titleSignup: 'Crea tu cuenta',
    titleLogin: 'Bienvenido de nuevo',
    introSignup: 'Mantén tus chats y consigue un asistente que te recuerde.',
    google: 'Continuar con Google',
    divider: 'o',
    showPassword: 'Mostrar contraseña',
    hidePassword: 'Ocultar contraseña',
    submitSignup: 'Crear cuenta',
    submitLogin: 'Iniciar sesión',
    switchToLoginPrefix: '¿Ya tienes una cuenta?',
    switchToLogin: 'Iniciar sesión',
    switchToSignupPrefix: '¿Nuevo en Poneva?',
    switchToSignup: 'Crear cuenta',
    close: 'Cerrar',
    verificationTitle: 'Revisa tu bandeja de entrada',
    verificationBody: 'Enviamos un enlace seguro a',
    verificationHint:
      'Abra el enlace del correo electrónico para crear su cuenta; cualquier dispositivo funciona. Mientras tanto, tu invitación espera.',
    verificationAgain: 'Utilice otra dirección de correo electrónico',
    verifying: 'Verificando tu correo electrónico y creando tu cuenta…',
    confirmPasswordTitle: 'Confirma tu contraseña',
    confirmPasswordBody:
      'Su correo electrónico está verificado. Abriste el enlace en un navegador diferente, así que ingresa la contraseña que elegiste para crear tu cuenta e inicia sesión aquí.',
    confirmPasswordPlaceholder: 'Tu contraseña',
    confirmPasswordSubmit: 'Crear cuenta e iniciar sesión',
    errors: {
      email_taken: 'Ese correo electrónico ya está registrado.',
      bad_credentials: 'Correo electrónico o contraseña incorrectos.',
      rate_limited: 'Demasiados intentos: espera un momento y vuelve a intentarlo.',
      invalid_input:
        'Ingrese un correo electrónico válido y una contraseña de al menos 8 caracteres.',
      cancelled: 'El inicio de sesión fue cancelado.',
      expired: 'El inicio de sesión tardó demasiado. Inténtalo de nuevo.',
      unverified_email:
        'Su cuenta de Google no tiene una dirección de correo electrónico verificada.',
      account_link_required:
        'Ya existe una cuenta con esa dirección. Inicia sesión con tu correo electrónico para vincular Google.',
      email_verification_required:
        'Verifique la dirección de correo electrónico por separado antes de usar esa cuenta de Google.',
      invalid_invite: 'Esa invitación no es válida, ha caducado o ya se ha utilizado.',
      verification_expired:
        'Ese enlace de verificación no es válido, ha caducado o ya se ha utilizado.',
      verification_password_required:
        'Ingrese la contraseña que eligió al registrarse para finalizar en este dispositivo.',
      verification_wrong_password:
        'Contraseña incorrecta. Ingrese la contraseña que eligió al registrarse.',
      oauth_failed: 'No se pudo iniciar sesión con Google. Por favor inténtalo de nuevo.',
      oauth_unavailable: 'El inicio de sesión de Google no está disponible en este momento.',
      server_unavailable:
        'El servicio no está disponible en este momento. Inténtelo de nuevo en breve.',
      logout_incomplete:
        'Es posible que este dispositivo siga con la sesión iniciada cuando la aplicación vuelva a abrirse. Si es así, cierre sesión de nuevo.',
      generic: 'Algo salió mal. Por favor inténtalo de nuevo.',
    },
  },
} satisfies Record<Exclude<EuAppLanguage, 'en' | 'sv'>, AuthStrings>;
